export default function TechStack() {
  return (
    <div className="px-4">
      <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Our Technology Stack</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 text-center">
        {/* Frontend Technologies */}
        <TechCard icon="fab fa-react" title="React.js" description="Frontend"/>
        
        {/* Mobile Development */}
        <TechCard icon="fas fa-mobile-alt" title="Flutter" description="Cross-platform"/>
        <TechCard icon="fab fa-app-store-ios" title="React Native" description="Native apps"/>
        
        {/* Backend Technologies */}
        <TechCard icon="fab fa-windows" title=".NET Core" description="Enterprise backend"/>
        <TechCard icon="fas fa-code" title="C#" description="Backend systems"/>
        <TechCard icon="fab fa-node-js" title="Node.js" description="API services"/>
        <TechCard icon="fab fa-golang" title="Golang" description="High-performance"/>
        
        {/* Message Brokers */}
        <TechCard icon="fas fa-exchange-alt" title="RabbitMQ" description="Message queue"/>
        <TechCard icon="fas fa-stream" title="Kafka" description="Event streaming"/>
        
        {/* Databases */}
        <TechCard icon="fas fa-database" title="MongoDB" description="NoSQL"/>
        <TechCard icon="fas fa-database" title="MySQL" description="Relational"/>
        <TechCard icon="fas fa-database" title="PostgreSQL" description="Advanced SQL"/>
        <TechCard icon="fas fa-bolt" title="Redis" description="Caching"/>
        
        {/* Cloud Providers */}
        <TechCard icon="fab fa-aws" title="AWS" description="Cloud services"/>
        <TechCard icon="fab fa-google" title="Google Cloud" description="GCP"/>
        <TechCard icon="fab fa-microsoft" title="Azure" description="Cloud solutions"/>
        
        {/* DevOps */}
        <TechCard icon="fas fa-server" title="Docker" description="Containers"/>
        <TechCard icon="fas fa-code-branch" title="Kubernetes" description="Orchestration"/>
        
        {/* Other Technologies */}
        <TechCard icon="fab fa-python" title="Python" description="AI/ML"/>
        <TechCard icon="fab fa-php" title="PHP" description="Web solutions"/>
      </div>
    </div>
  );
}

// Reusable TechCard component
function TechCard({ icon, title, description }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all hover:-translate-y-1">
      <div className="text-blue-600 text-4xl mb-4">
        <i className={icon}></i>
      </div>
      <h3 className="font-bold text-gray-800">{title}</h3>
      <p className="text-sm text-gray-500 mt-1">{description}</p>
    </div>
  );
}